/* 
 * Export component file to be used on project
*/

import NpsTextArea from './NpsTextArea';
export default NpsTextArea;